// ABOUTME: Dealership the current screen works in (catalogue, cart, offer), and the user's last choice, per tab.
// ABOUTME: The current one lives in memory for the fetch wrapper and Apollo link; the last choice in sessionStorage, per user.

import type { DealershipChoice } from './types';

/** Followed by the username: another user in the same tab does not start on this one's choice. */
const LAST_CHOICE_KEY_PREFIX = 'pim.lastDealershipChoice.';
/** Stored for a "none" choice, told apart from no choice at all; a dealership id is never empty. */
const NONE_CHOICE = '';

let requestDealership: string | undefined;

/** The dealership the current screen works in, or undefined when it works without one. */
export const getRequestDealership = (): string | undefined => requestDealership;

/** Sets (or, with undefined, clears) the dealership the next requests carry. */
export const setRequestDealership = (dealershipId: string | undefined) => {
    requestDealership = dealershipId;
};

// Storage can be unavailable (privacy modes, sandboxed frames): a missing storage means no choice.
const getSessionStorage = (): Storage | undefined => {
    try {
        return (globalThis as unknown as { sessionStorage?: Storage }).sessionStorage;
    } catch {
        return undefined;
    }
};

/** What the user last picked in this tab (catalogue or cart): a dealership or "none"; undefined before any pick. */
export const getLastDealershipChoice = (
    username: string | undefined,
): DealershipChoice | undefined => {
    if (!username) return undefined;
    let stored: string | null | undefined;
    try {
        stored = getSessionStorage()?.getItem(`${LAST_CHOICE_KEY_PREFIX}${username}`);
    } catch {
        return undefined;
    }
    if (stored === null || stored === undefined) return undefined;
    return stored === NONE_CHOICE ? { kind: 'none' } : { kind: 'dealership', dealershipId: stored };
};

/** Remembers the dealership the user picked, or "none" for undefined. */
export const setLastDealershipChoice = (
    username: string | undefined,
    dealershipId: string | undefined,
) => {
    if (!username) return;
    const key = `${LAST_CHOICE_KEY_PREFIX}${username}`;
    try {
        getSessionStorage()?.setItem(key, dealershipId || NONE_CHOICE);
    } catch {
        // storage unavailable: the choice is not remembered
    }
};
